import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "search",
})
@Injectable({
  providedIn: "root",
})
export class SearchPipe implements PipeTransform {
  transform(value: any = [], args?: any, unfiltered: any = []): any {
    console.log("unif", unfiltered);
    if (value.length === 0 || !args) {
      return unfiltered;
    }

    const filterValue = args;
    if (value && value.data) {
      //data from material Data Table

      value.filter = filterValue.trim().toLowerCase();
      return value.filteredData;
    } else {
      return value.filter((item) => {
        return Object.keys(item).some((key) => {
          return String(item[key])
            .toLowerCase()
            .includes(filterValue.toLowerCase());
        });
      });
    }
  }
}
